import { apiRoutes } from '../../api-routes';
import { epApiUrl } from '../../constants';
import { httpClient } from '../../util';
import type { BatchGeocodeReq, BatchGeoCode } from './types';

export const batchGeocodeFn = async (body: BatchGeocodeReq) => {
  const response = await httpClient.post<BatchGeoCode[]>(
    epApiUrl + apiRoutes.place.batchGeocode,
    { ...body }
  );

  return response.data;
};
